module.exports = __webpack_public_path__ + "assets/plus.b087e4fa.svg";